import { render, staticRenderFns } from "./title-who-pays.vue?vue&type=template&id=78cc91ea"
import script from "./title-who-pays.vue?vue&type=script&lang=js"
export * from "./title-who-pays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports